export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#6B3077',
    contrastText: '#FFFFFF',
    light: '#F1FAFE',
  },
  secondary: {
    main: '#004485',
    contrastText: '#002855',
  },
  text: {
    primary: '#141B22',
    custom: '#0085AD',
    light: '#64748B',
    secondary: '#141B22',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#EBFBFF',
    primary: '#3FAFC7',
    secondary: '#4E9ED6',
    paper: '#FFF',
    default: '#FFF',
    header: '#DFF2F6',
    footer: '#006298',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#006298',
    tableSubhead: '#F7F7F7',
    arrow: '#006298',
    tableAlternate: '#F8F8F8',
    alternate: '#E3F1FD',
    success: '#DBEFDC',
    error: '#FFEAEA',
  },
  verticalBar: {
    used: '#6B3077',
    unused: '#f0eaf1',
    unlimited: '#C0C0C0',
  }
};
